import { ButtonProps, Icon } from "@zapier/design-system";
import { Suspense } from "react";
import { GoogleSSOButton } from "src/components/GoogleSSOButton";
import { UseTemplateButton } from "src/components/UseTemplateButton";
import { type ZapCardTemplate } from "src/components/ZapCard";
import { type Product } from "src/server/zsl/templates/types";
import styles from "./TemplateLIbraryDetailCTAs.module.css";

type TemplateLibraryDetailCTAsProps = {
  template: ZapCardTemplate;
  buttonSize: ButtonProps["size"];
};

export const TemplateLibraryDetailCTAs = ({
  template,
  buttonSize,
}: TemplateLibraryDetailCTAsProps) => {
  return (
    <Suspense>
      <GoogleSSOButton size={buttonSize} slug={template.slug}>
        Continue with Google
      </GoogleSSOButton>
      <UseTemplateButton
        slug={template.slug}
        products={template.products?.items as Product[]}
        size={buttonSize}
      >
        <span className={styles.buttonContent}>
          Use this template
          <Icon name="arrowBigRight" />
        </span>
      </UseTemplateButton>
    </Suspense>
  );
};
